module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.19801/js/img/ebx633/hero-bg.svg"